import { render, staticRenderFns } from "./LightboxImageCard.vue?vue&type=template&id=6d084fcd&scoped=true"
import script from "./LightboxImageCard.vue?vue&type=script&lang=js"
export * from "./LightboxImageCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d084fcd",
  null
  
)

export default component.exports